import React from 'react';
import { Link } from 'react-router-dom';
import { researchArticles } from '../data/researchArticles';


const Home: React.FC = () => {
    return (
        <main id="main-content" className="w-full" role="main">
            {/* Hero Section */}
            <section id="hero" className="relative min-h-[60vh] md:h-[65vh] bg-canvas flex items-start justify-center pt-32 pb-12 md:pt-40 md:pb-0">
                {/* Content */}
                <div className="relative z-10 container mx-auto px-6 md:px-16 lg:px-24 text-center">
                    <h1 className="text-h1 md:text-hero mb-6 animate-fade-in-up">
                        Intelligence, Reimagined.
                    </h1>
                    <p className="max-w-2xl mx-auto animate-fade-in-up delay-200">
                        SilentLabs is a technology and research company. Our mission is to design and develop tools that adapt to humans — not the other way around.
                    </p>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4 mt-8 animate-fade-in-up delay-300">
                        <Link
                            to="/products"
                            className="inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-text-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors"
                        >
                            Explore Products
                        </Link>
                        <Link
                            to="/research"
                            className="inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-text-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors"
                        >
                            Explore Research
                        </Link>
                    </div>
                </div>
            </section>

            {/* Research Section */}
            <section id="research" className="py-8 md:py-16 bg-canvas px-6 md:px-12">
                {/* Mobile: Title outside the box */}
                <h2 className="md:hidden mb-4 text-center">Research</h2>

                <div className="bg-canvas-alt rounded-3xl p-8 md:p-16">
                    {/* Desktop: Title + Link row inside the box */}
                    <div className="hidden md:flex justify-between items-baseline mb-16">
                        <h2 className="">Core Research</h2>
                        <Link to="/research" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                            View All Areas →
                        </Link>
                    </div>

                    <div className="space-y-0">
                        {researchArticles.map((article) => (
                            <Link key={article.slug} to={`/research/${article.slug}`} className="group py-12 md:py-16 border-t border-border flex items-start justify-between gap-6 block transition-all duration-500">
                                <div className="flex-1 max-w-2xl">
                                    {article.date && (
                                        <p className="mb-4 text-sm tracking-[0.08em] text-text-secondary">
                                            {article.date}
                                        </p>
                                    )}
                                    <h2 className="mb-3 text-xl md:text-2xl font-medium tracking-tight">{article.title}</h2>
                                    <p className="text-balance leading-relaxed text-text-secondary">
                                        {article.description}
                                    </p>
                                </div>
                                <span className="text-2xl text-text-primary opacity-0 group-hover:opacity-100 group-hover:translate-x-2 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)]">→</span>
                            </Link>
                        ))}
                    </div>

                    {/* Mobile: Link at bottom, left-aligned */}
                    <div className="md:hidden flex justify-start mt-8">
                        <Link to="/research" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                            View All Areas →
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Home;
